// extracted by mini-css-extract-plugin
module.exports = {"container":"FullWidthLayout_container__YqBkV","fullWidthLayout":"FullWidthLayout_fullWidthLayout__yOR1S"};